.dda-home-carousel {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.dda-home-carousel-track {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
}


.dda-home-carousel-track::-webkit-scrollbar {
  display: none;
}


/* Default (Desktop) - using items_in_view via inline style (already applied in component) */
.dda-home-carousel-item {
  scroll-snap-align: start;
  flex-shrink: 0;
  padding: 0px 2px;
  padding-top: 30px;
  overflow: hidden;
  /* width set via inline style like: style={{ flex: `0 0 ${itemWidth}%` }} */
}


@media (max-width: 1200px) {
  .dda-home-carousel-item {
    flex: 0 0 24% !important; 
  }
}


@media (max-width: 1024px) {
  .dda-home-carousel-item {
    flex: 0 0 32% !important;
  }
}


@media (max-width: 768px) {
  .dda-home-carousel-item {
    flex: 0 0 48% !important;
  }
}

@media (max-width: 576px) {
  .dda-home-carousel-item {
    flex: 0 0 97% !important;
  }
}


.dda-home-carousel .dda-banner-card {
    height: 100%;
    transform: translate(0, 0px);
    padding-bottom: 24px;
}
.dda-home-carousel .dda-banner-card::after{
  content: "";
  width: 20px;
  height: 20px;
  background-color: var(--dda-surface-100);
  border-radius: 0px 0px 5px 0px;
  position: absolute;
  bottom: 0px;
  transform: rotate(45deg);
  left: 50%;
  margin-left: -10px;
  /* transition: 0.3s; */
}
.dda-home-carousel .dda-banner-card:hover::after,
.dda-home-carousel .dda-banner-card.active::after{
  bottom: -9px;
}
.dda-home-carousel .dda-banner-card.active {
    box-shadow: 0px 0px 7px 4px rgba(0, 0, 0, 0.05);
}
@media (min-width: 1024px) {
  .dda-home-carousel-item:hover .dda-banner-card,
  .dda-home-carousel-item .dda-banner-card.active {
      transform: translate(0, -25px);
  }
}
@media (max-width: 1024px) {
  .dda-home-carousel-item .dda-banner-card {
    border-radius: 16px;
  }
}

/*********************Placing style on the home page*************************/
.dda-home-quick-links-wrap {
    width: 100%;
    z-index: 1;
    position: absolute;
    bottom: 50px;
}
.dda-home-quick-links {
  width: 90vw;
  margin: 0 auto;
  gap: 8px;
  padding: 0 20px;
}
@media screen and (max-width: 1024px) {
    .dda-home-quick-links-wrap{
        bottom: 100px;
        padding-bottom: 0px;
    }
    .dda-home-quick-links{
      width: 100vw;
    }
}

@media (prefers-reduced-motion: no-preference) {
  .dda-home-carousel .dda-banner-card::after{
    transition: 0.3s;
  }
}

